const CsvUtils = {

    csvEscape: function (value) {
        const s = value == null ? "" : String(value);
        const normalized = s.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        const mustQuote = /[",\n;]/.test(normalized); // include ; too
        const escaped = normalized.replace(/"/g, '""');
        return mustQuote ? `"${escaped}"` : escaped;
    },

    toCsv: function (rows, {delimiter = ",", eol = "\r\n"} = {}) {
        return rows
            .map(row => row.map(v => this.csvEscape(v)).join(delimiter))
            .join(eol);
    }
};

export default CsvUtils;
